export default {"src":"/_next/static/media/uy.cbecd781.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};